module.exports = __webpack_public_path__ + "static/img/pro-icon-2.32f1bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/pro-icon-2.jpg
// module id = cTGT
// module chunks = 13